// EmptyState.tsx — Centered "nothing to show" placeholder.

interface Props {
  icon?: string;
  title: string;
  body?: string;
}

export function EmptyState({ icon = 'inbox', title, body }: Props) {
  return (
    <div className="console-empty">
      <span className="material-icons">{icon}</span>
      <div className="console-empty-title">{title}</div>
      {body && <div>{body}</div>}
    </div>
  );
}
